import React, {useState} from 'react'
import {Button, Input} from 'react-daisyui'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import clsx from 'clsx'
import {useForm} from 'react-hook-form'
import {usePostOTAReservationMutation} from '../../services/guestPortalApi'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'

export const AddOTAReservationForm = ({
  onFormSubmit
}: {
  onFormSubmit?: Function
}) => {
  const {
    register,
    handleSubmit,
    formState: {errors},
    watch
  } = useForm()

  const handleFormSubmit = (data: any) => {
    event.preventDefault()
    if (onFormSubmit) {
      onFormSubmit(data)
    }
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <div>
        <label className="label pb-1">Booking Platform</label>
        <select
          {...register('ota', {required: true})}
          className="select select-bordered w-full"
          name="ota"
        >
          <option disabled selected>
            Select one
          </option>
          <option value={'Airbnb'}>Airbnb</option>
          <option value={'Booking'}>Booking.com</option>
          <option value={'Expedia'}>Expedia</option>
        </select>
        {errors.ota?.type === 'required' && (
          <p className="text-red-500" role="alert">
            OTA is required
          </p>
        )}
      </div>

      <div>
        <label
          className={
            'label pb-1' + (errors.confirmationCode ? ' text-red-error' : '')
          }
        >
          Confirmation code:
        </label>
        <Input
          {...register('confirmationCode', {
            required: true
          })}
          className={
            'input-form' + (errors.confirmationCode ? ' input-form-error' : '')
          }
          type="text"
          name="confirmationCode"
        />
        {errors.confirmationCode?.type === 'required' && (
          <p className="text-red-500" role="alert">
            Confirmation code is required
          </p>
        )}
      </div>

      <div>
        <label
          className={'label pb-1' + (errors.lastName ? ' text-red-error' : '')}
        >
          Last name on reservation:
        </label>
        <Input
          {...register('lastName', {
            required: true,
            pattern: /^[A-Za-z]+$/i
          })}
          className={
            'input-form' + (errors.lastName ? ' input-form-error' : '')
          }
          type="text"
          name="lastName"
        />
        {errors.lastName?.type === 'required' && (
          <p className="text-red-500" role="alert">
            Last name is required
          </p>
        )}
        {errors.lastName?.type === 'pattern' && (
          <p className="text-red-500" role="alert">
            Invalid last name
          </p>
        )}
      </div>
      <Button color="secondary" className="w-full mt-8" type="submit">
        import reservation information
      </Button>
    </form>
  )
}

export default AddOTAReservationForm
